import { type StructuredContentDocument } from '@repo/contracts/multi-use/structured-content/types';
import BaseEmbed from './BaseEmbed';

export type InfogramProps = StructuredContentDocument<{
  id: string;
}>;

export function Infogram({ props: { id } }: InfogramProps) {
  const src = `https://e.infogr.am/${id}?src=embed#async_embed`;

  return <BaseEmbed src={src} title="Infogram" />;
}
